import { Box } from "@chakra-ui/react";
import { Transition } from "react-transition-group";

const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 1 },
  exited: { opacity: 0 }
};

export default function FadeTransition({
  show,
  children,
  inDelay,
  outDelay,
  timeout = 300,
  ...rest
}) {
  return (
    <Transition in={show} timeout={timeout} {...rest}>
      {(state) => (
        <Box
          transition={`opacity ${timeout}ms`}
          {...transitionStyles[state]}
          {...(inDelay && show && { transitionDelay: inDelay })}
          {...(outDelay && !show && { transitionDelay: outDelay })}
        >
          {children}
        </Box>
      )}
    </Transition>
  );
}
